/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsQueueJob,
    EfsMelcoEfsModelsQueueJobFromJSON,
    EfsMelcoEfsModelsQueueJobFromJSONTyped,
    EfsMelcoEfsModelsQueueJobToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsQueueJob>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob
     */
    list: Array<EfsMelcoEfsModelsQueueJob>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsQueueJobFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob {
    return EfsMelcoModelsGenericList1MelcoEfsModelsQueueJobFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsQueueJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsQueueJobFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsQueueJobToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsQueueJob | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsQueueJobToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


